import React from "react"
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter"
import { darcula } from "react-syntax-highlighter/dist/esm/styles/prism"
import PropTypes from "prop-types"

const CodeViewer = ({ code, language = "typescript", height = 'auto' }) => {
    return (
        <div
            style={{
                background: "#1e1e1e",
                borderRadius: "8px",
                padding: "16px",
                overflow: "auto",
                height,
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            }}
        >
            <SyntaxHighlighter
                language={language}
                style={darcula}
                wrapLongLines
                customStyle={{
                    width: "100%",
                    background: "#1e1e1e",
                    padding: "16px",
                    fontSize: "14px",
                    borderRadius: "8px",
                }}
                showLineNumbers
            >
                {code}
            </SyntaxHighlighter>
        </div>
    )
}

CodeViewer.propTypes = {
    code: PropTypes.element,
    language: PropTypes.string,
    height: PropTypes.number,
}

export default CodeViewer